<template>
  <el-dialog
    class="modal"
    :model-value="modelValue"
    width="426px"
    align-center
    :show-close="false"
    :append-to-body="true"
    @closed="$emit('update:modelValue'), $emit('close')"
  >
    <TheIcons
      v-if="!noIcon"
      :name="icon"
      width="50"
      height="50"
      viewBox="0 0 50 50"
    />

    <slot />

    <template #footer v-if="!footerHide">
      <span class="modal__footer">
        <el-button class="btn-white body-2" @click="clickCancel">{{
          cancel ? cancel : $t('button.cancel')
        }}</el-button>

        <el-button
          class="btn-red"
          :disabled="validate || loading"
          :loading="loading"
          @click="$emit('confirm')"
        >
          {{ confirm }}
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import TheIcons from '@/components/icons/TheIcons.vue'

const emit = defineEmits(['update:modelValue', 'close', 'confirm', 'cancel'])

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  icon: { type: String, default: 'login' },
  confirm: { type: String, default: 'Confirm' },
  cancel: { type: String, default: null },
  noIcon: { type: Boolean, default: false },
  validate: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  footerHide: { type: Boolean, default: false },
})

const clickCancel = () => {
  if (props.cancel) {
    emit('cancel')
  } else {
    emit('update:modelValue')
  }
}
</script>
